module.exports = __webpack_public_path__ + "img/transition-cover-0.dc61f7d.svg";